import terms from '../views/nca/terms.vue'
import schedule from '../views/nca/schedule.vue'

export default [
  {
    path: '/nca/terms/:survNo',
    name: 'terms',
    props: true,
    component: terms
  },
  {
    path: '/nca/schedule/:survNo/:userNo',
    name: 'schedule',
    props: true,
    component: schedule
  }
]



// WEBPACK FOOTER //
// ./src/router/nca.js